module.exports = __webpack_public_path__ + "static/img/cygn5.1255abe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/cygn5.png
// module id = 314
// module chunks = 0